export default __webpack_public_path__ + "static/media/plan.915fe212.jpg";